const isNil = a => a === undefined || a === null;
export default isNil;